export const MAX_FILE_SIZE = 10485760;
export const MAX_FILE_SIZE_MB = MAX_FILE_SIZE / 1024 / 1024;
export const MIN_FILE_LIMIT = 1;
export const MAX_FILE_LIMIT = 10;

export const ALLOWED_IMAGE_EXTENSIONS_LIST =
	'jfif|bmp|gif|png|jpeg|jpg|ico|webp|avif'.split('|');

export const ALLOWED_FILE_EXTENSIONS_LIST = 'pdf|doc|docx|xls|xlsx|slk|vlr'
	.split('|')
	.concat(ALLOWED_IMAGE_EXTENSIONS_LIST);

export const convertFormatArrayToFileExtensionsString = (
	fileExtensions: string[]
) =>
	fileExtensions
		.map((ext) => `.${ext}`)
		.join(', ')
		.trim();

export const IMAGE_EXTENSIONS_STRING = convertFormatArrayToFileExtensionsString(
	ALLOWED_IMAGE_EXTENSIONS_LIST
);

export const ALLOWED_FILE_EXTENSIONS_STRING =
	convertFormatArrayToFileExtensionsString(ALLOWED_FILE_EXTENSIONS_LIST);

// image/* keeps image preview/upload working in VCDK FileUploader.
// Explicit MIME types are added since some pickers/components validate by MIME, not just extension.
export const ALLOWED_UPLOAD_MIME_TYPES = `image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,${ALLOWED_FILE_EXTENSIONS_STRING.replace(
	/\s+/g,
	''
)}`;

export const ALLOWED_VODIA_FILE_EXTENSIONS_LIST = ['pdf', 'doc', 'docx'];

export const convertFormatArrayToExtensionsValidationRegexp = (
	fileExtensions: string[]
) => new RegExp(`.(${fileExtensions.join('|')})$`);

export const IMAGE_EXTENSIONS_REGEX =
	convertFormatArrayToExtensionsValidationRegexp(
		ALLOWED_IMAGE_EXTENSIONS_LIST
	);
export const ALLOWED_FILE_EXTENSION_REGEX =
	convertFormatArrayToExtensionsValidationRegexp(
		ALLOWED_FILE_EXTENSIONS_LIST
	);

export const isValidFileUploadSize = (file: FileValidatable) => {
	return file.size <= MAX_FILE_SIZE;
};

export const isValidFileUploadDuplicates = (
	uploadedFiles: FileValidatable[],
	currentFile: FileValidatable
) => {
	return !uploadedFiles.find(
		({ lastModified, size, type }) =>
			currentFile.lastModified === lastModified &&
			currentFile.size === size &&
			currentFile.type === type
	);
};

export interface FileValidatable {
	lastModified: number;
	size: number;
	type: string;
}

export const formatSizeShort = (sizeBytes: number) => {
	if (!Number.isFinite(sizeBytes) || sizeBytes < 0) {
		return '';
	}

	const kib = 1024;
	const mib = kib * 1024;
	const gib = mib * 1024;

	if (sizeBytes < kib) {
		return `${Math.round(sizeBytes)}B`;
	}

	if (sizeBytes < mib) {
		return `${Math.round(sizeBytes / kib)}K`;
	}

	if (sizeBytes < gib) {
		return `${Math.round(sizeBytes / mib)}M`;
	}
	return `(${Math.round(sizeBytes / gib)}G)`;
};
